var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h3',{class:_vm.resultClass},[_vm._v(_vm._s(_vm.result))]),_c('LoadingSplash',{attrs:{"loading":_vm.busy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }